import { Component, inject, OnDestroy, OnInit, ViewEncapsulation } from "@angular/core";
import { toSignal } from "@angular/core/rxjs-interop";
import { MCFormisForm, MCConfigService, MCFormValidationService, MCFormStateService } from "@maslul/common-services";
import { MCButtonComponent, MCFieldFormComponent } from "@maslul/common-components";
import { RequestDetailsService } from "../../../../../services/pages/request-details/request-details";
import { Subscription } from "rxjs";
import { FormlyFieldConfig, FormlyModule } from "@ngx-formly/core";
import { ReactiveFormsModule } from "@angular/forms";
import { RequestDetailsStore } from "../../../../../services/store/request-details";
import { ProductsService } from "../../../../../services/pages/products/products";
import cloneDeep from 'clone-deep';
import { TranslateService } from "@ngx-translate/core";
import { GeneralSkeletonComponent } from "../../components/general-skeleton/general-skeleton";
import { PageBaseComponent } from "../../../../shared/page-base";
import { FocusOnTabDirective } from "../../../../../services/shared/directives/focus-on-tab";
import { GeneralStore } from "../../../../../services/store/general";
import { RequestApprovalTypeDetailsStore } from "../../../../../services/store/approval-type-details-store";
import { TABS } from "../../../../../enum/request/TABS";


@Component({
    selector: 'mi-request-details',
    imports: [
        MCFieldFormComponent,
        ReactiveFormsModule,
        FormlyModule,
        MCButtonComponent,
        GeneralSkeletonComponent,
        FocusOnTabDirective
    ],
    templateUrl: './request-details.html',
    styleUrl: './request-details.scss',
    encapsulation: ViewEncapsulation.None
})
export class RequestDetailsComponent extends PageBaseComponent implements OnInit, OnDestroy {

    private formStateService = inject(MCFormStateService);
    private translateService = inject(TranslateService);
    private requestDetailsService = inject(RequestDetailsService);
    private formValidationService = inject(MCFormValidationService);
    private requestDetailsStore = inject(RequestDetailsStore);
    private productService = inject(ProductsService);
    private configService = inject(MCConfigService);
    private requestApprovalTypeDetailsStore = inject(RequestApprovalTypeDetailsStore);
    private generalStore = inject(GeneralStore);

    formisForm: MCFormisForm = new MCFormisForm();
    subscription: Subscription = new Subscription();
    tabsText = toSignal(this.translateService.stream('tabs'));
    genericText = toSignal(this.translateService.stream('generic'));
    isExistAtachmnets: boolean = true;


    ngOnInit() {
        this.initFormisForm();
        this.initIsExistAttachments();
    }

    initIsExistAttachments() {
        this.isExistAtachmnets = this.requestApprovalTypeDetailsStore.getSnapshot().approvalTabs.includes(TABS.ATTACHMENTS);
    }



    initFormisForm() {
        this.formisForm.options.formState = this.formStateService.getFormState();
        //this.formisForm.form = new FormGroup({});
        this.formisForm.model = cloneDeep(this.requestDetailsStore.getSnapshot().formisFormModel);
        this.initFields();


    }
    initFields() {
        this.subscription.add(
            this.requestDetailsService.getFields(this.formisForm)
                .subscribe((formisFormFields: Array<FormlyFieldConfig> | undefined) => {
                    if (formisFormFields) {
                        this.formisForm.fields = formisFormFields;
                    }
                }))
            ;
    }


    next() {
        const isValid = this.formisForm.form.valid;

        this.requestDetailsStore.setFormisFormModel(cloneDeep(this.formisForm.model));

        if (isValid || (!this.isNewRequest && this.requestId) || this.configService.getConfiguration().noValidCheck == "true") {
            this.requestDetailsService.saveFormState(cloneDeep(this.formisForm.model));

            if (this.isExistAtachmnets) {
                this.navigate('attachments')
            } else {
                this.navigate('declarations');
            }

        }
        else {
            this.formisForm.form.markAllAsTouched();
            const invalidFields = this.formValidationService.getInvalidControlsFlatMap(this.formisForm.form);
            console.log('request details get invalid field', invalidFields);


        }
    }

    ngOnDestroy(): void {
        this.subscription.unsubscribe();
    }

    back() {
        this.moveToProduct();
    }

    moveToProduct(): void {
        this.requestDetailsStore.setFormisFormModel(cloneDeep(this.formisForm.model));

        this.productService.prevToProductTab();
    }
}